import _ from 'lodash'
window._ = _

import Moment from 'moment'
import { extendMoment } from 'moment-range'
extendMoment(Moment)
window.moment = Moment

import 'cropperjs'
import heic2any from 'heic2any'
window.heic2any = heic2any

import '~adminlte/dist/js/adminlte'
import Swal from 'sweetalert2'
import 'bootstrap-datepicker'
import ClipboardJS from 'clipboard'
window.ClipboardJS = ClipboardJS
window.Swal = Swal

import '~vendor/rappasoft/laravel-livewire-tables/resources/imports/laravel-livewire-tables-all.js'
import '~vendor/masmerise/livewire-toaster/resources/js'